import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  initSideMenu,
  updateSideMenu,
  SideMenuState,
  initSelectedQuotation,
  updateSelectedQuotation,
  QuotationIdType,
  initDashboard,
  initDisabledSideMenu,
  updateDisabledSideMenu
} from '@modules/dashboard';

export default function useDashboard() {
  const dispatch = useDispatch();

  const onInitDashboard = useCallback(
    () => dispatch(initDashboard()),
    [dispatch]
  );

  const onInitSideMenu = useCallback(
    () => dispatch(initSideMenu()),
    [dispatch]
  );

  const onUpdateSideMenu = useCallback(
    (menu: SideMenuState) => dispatch(updateSideMenu(menu)),
    [dispatch]
  );

  const onInitSelectedQuotation = useCallback(
    () => dispatch(initSelectedQuotation()),
    [dispatch]
  );
  const onUpdateSelectedQuotation = useCallback(
    (payload: QuotationIdType) => dispatch(updateSelectedQuotation(payload)),
    [dispatch]
  );

  const onInitDisabledSideMenu = useCallback(
    () => dispatch(initDisabledSideMenu()),
    [dispatch]
  );
  const onUpdateDisabledSideMenu = useCallback(
    (payload: SideMenuState[]) => dispatch(updateDisabledSideMenu(payload)),
    [dispatch]
  );

  return {
    onInitDashboard,

    onInitSideMenu,
    onUpdateSideMenu,

    onInitSelectedQuotation,
    onUpdateSelectedQuotation,

    onInitDisabledSideMenu,
    onUpdateDisabledSideMenu
  };
}
